{#if loggedIn}
<div class="app">
  <Sidebar />
  <div class="content">
    <div class="grid-container">
      <Router />
    </div>
  </div>
  <Notifications />
</div>
{:else}
<Login />
{/if}

<svelte:head>
  <style lang="scss">
    @import "./app.scss";

    h1 {
      margin: 40px 0 56px 0;
      font-family: proxima-nova, sans-serif;
      font-weight: 300;
      color: #4c4c4b;
    }

    body,
    html {
      padding: 0;
      margin: 0;
      position: initial;
    }

    .doka--root {
      .doka--button-action-confirm {
        background-color: darken(#ff6452, 7);
        color: #fff;

        &:hover {
          background-color: #ff6452;
        }
      }
    }


    .flatpickr-calendar {
      font-family: proxima-nova, sans-serif;
      box-shadow: 0 9px 23px rgba(0, 0, 0, 0.25);
    }

    .flatpickr-day {
      font-family: proxima-nova, sans-serif;
    }

    .flatpickr-months .flatpickr-month {
      background: #f2f2f3;
      color: #4c4c4b;
      font-family: proxima-nova, sans-serif;
    }

    .flatpickr-weekdays {
      background: #f2f2f3;
      color: #4c4c4b;
      font-family: proxima-nova, sans-serif;
    }

    span.flatpickr-weekday {
      background: #f2f2f3;
      color: #4c4c4b;
      font-family: proxima-nova, sans-serif;
    }

    span.flatpickr-day.selected {
      background-color: #ff6452;
      border-color: #ff6452;
    }

    .flatpickr-day.today {
      border-color: #f2f2f3;
    }
  </style>
</svelte:head>

<script>
  import { setContext } from 'svelte';
  import Router from './router.html';
  import Sidebar from './components/navigation/sidebar';
  import { client } from './apollo/client';
  import { createBrowserHistory } from 'history';
  import Notifications from './utils/notifications';
  import { session } from './utils/session.store';
  import TextInput from './components/inputs/text';
  import gql from 'graphql-tag';
  import store from 'store';
  import Login from './routes/login/login';

  let email;
  let password;
  let loggedIn = false;

  const SESSION = gql`
    query {
      adminSessionStillActive
    }
  `

  function checkLoginStatus() {
    client.query({ query: SESSION }).then(() => {
      console.log('session is still active');
    }).catch(e => {
      console.log('session is no longer active');
      store.remove('token')
      window.location.reload();
    })
  }


  const unsubscribe = session.subscribe(value => {
    loggedIn = value.loggedIn;
  });

  if (loggedIn) {
    checkLoginStatus();
  }


  const history = createBrowserHistory();

  setContext('history', history);
  setContext('apollo', client);
</script>